import React from 'react';
import './ActivitySection.css';

interface ActivitySectionProps {
  className?: string;
}

interface ActivityItem {
  id: string;
  type: 'deposit' | 'withdrawal' | 'trade' | 'bonus';
  title: string;
  description: string;
  amount: string;
  timestamp: string;
  status: 'completed' | 'pending' | 'failed';
}

export const ActivitySection: React.FC<ActivitySectionProps> = ({ className }) => {
  const activities: ActivityItem[] = [
    {
      id: '1',
      type: 'deposit',
      title: 'Deposit',
      description: 'Card ending in 4532',
      amount: '+$500.00',
      timestamp: 'Today, 2:30 PM',
      status: 'completed'
    },
    {
      id: '2',
      type: 'trade',
      title: 'Options Trade',
      description: 'EUR/USD Rise/Fall',
      amount: '+$25.50',
      timestamp: 'Today, 1:45 PM',
      status: 'completed'
    },
    {
      id: '3',
      type: 'trade',
      title: 'Options Trade',
      description: 'GBP/USD Higher/Lower',
      amount: '-$10.00',
      timestamp: 'Today, 12:20 PM',
      status: 'completed'
    },
    {
      id: '4',
      type: 'withdrawal',
      title: 'Withdrawal',
      description: 'To wallet ending in xyz',
      amount: '-$200.00',
      timestamp: 'Yesterday, 4:15 PM',
      status: 'pending'
    },
    {
      id: '5',
      type: 'bonus',
      title: 'Welcome Bonus',
      description: 'New account bonus',
      amount: '+$50.00',
      timestamp: 'Nov 15, 10:00 AM',
      status: 'completed'
    }
  ];

  const getActivityIcon = (type: ActivityItem['type']) => {
    switch (type) {
      case 'deposit':
        return '↓';
      case 'withdrawal':
        return '↑';
      case 'trade':
        return '📊';
      case 'bonus':
        return '🎁';
      default:
        return '•';
    }
  };

  const getStatusClass = (status: ActivityItem['status']) => {
    switch (status) {
      case 'completed':
        return 'status-completed';
      case 'pending':
        return 'status-pending';
      case 'failed':
        return 'status-failed';
      default:
        return '';
    }
  };

  const getAmountClass = (amount: string) => {
    return amount.startsWith('+') ? 'amount-positive' : 'amount-negative';
  };

  return (
    <section className={`activity-section ${className || ''}`}>
      <div className="activity-header">
        <h2 className="activity-title">Recent Activity</h2>
        <button className="view-all-btn">
          View All
        </button>
      </div>

      <div className="activity-list">
        {activities.map((activity) => (
          <div key={activity.id} className="activity-item">
            <div className="activity-icon">
              {getActivityIcon(activity.type)}
            </div>
            
            <div className="activity-info">
              <div className="activity-main">
                <span className="activity-name">{activity.title}</span>
                <div className={`activity-status ${getStatusClass(activity.status)}`}>
                  {activity.status}
                </div>
              </div>
              <div className="activity-description">{activity.description}</div>
              <div className="activity-timestamp">{activity.timestamp}</div>
            </div>
            
            <div className={`activity-amount ${getAmountClass(activity.amount)}`}>
              {activity.amount}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
